var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"explain"},[_c('LogDetailView',{attrs:{"LogDetail":_vm.LogDetail,"objectType":_vm.objectType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }